"use client";

import Image from "next/image";
import React from "react";

interface DealButtonProps {
  dealType: string;
  onClick: () => void;
  marketAverage: number | null;
  className?: string;
}

const DealButton: React.FC<DealButtonProps> = ({
  dealType,
  onClick,
  marketAverage,
  className = "",
}) => {
  if (dealType === "none" || !marketAverage) return null;

  const getDealColor = () => {
    switch (dealType) {
      case "great":
        return "bg-white border border-[#2e7d32] text-[#1c1c1c]";
      case "good":
        return "bg-white border border-[#adeb83] text-[#1c1c1c]";
      case "fair":
        return "bg-white border border-[#f9dd8d] text-[#1c1c1c]";
      case "bad":
        return "bg-white border border-[#ff2c2c] text-[#1c1c1c]";
      case "poor":
        return "bg-white border border-[#ff5721] text-[#1c1c1c]";
      default:
        return "bg-white border border-[#6c6c6c] text-[#1c1c1c]";
    }
  };

  const getDealText = () => {
    switch (dealType) {
      case "great":
        return "Great Deal";
      case "good":
        return "Good Deal";
      case "fair":
        return "Fair Deal";
      case "bad":
        return "Bad Deal";
      case "poor":
        return "Poor Deal";
      default:
        return "Deal";
    }
  };

  return (
    <button
      onClick={onClick}
      className={`px-1.5 py-0 font-raleway text-[12px] font-normal transition-colors hover:opacity-80 flex items-center gap-1.5 ${getDealColor()} ${className}`}
    >
      {/* Deal Icon */}
      <div className="w-6 h-6 flex items-center justify-center">
        {dealType === "great" && (
          <Image
            src="/icons/deal-great.svg"
            alt="Great Deal"
            width={24}
            height={24}
            className="w-6 h-6"
          />
        )}
        {dealType === "good" && (
          <Image
            src="/icons/deal-good.svg"
            alt="Good Deal"
            width={24}
            height={24}
            className="w-6 h-6"
          />
        )}
        {dealType === "fair" && (
          <Image
            src="/icons/deal-fair.svg"
            alt="Fair Deal"
            width={24}
            height={24}
            className="w-6 h-6"
          />
        )}
        {dealType === "bad" && (
          <Image
            src="/icons/deal-bad.svg"
            alt="Bad Deal"
            width={24}
            height={24}
            className="w-6 h-6"
          />
        )}
        {dealType === "poor" && (
          <Image
            src="/icons/deal-poor.svg"
            alt="Poor Deal"
            width={24}
            height={24}
            className="w-6 h-6"
          />
        )}
      </div>
      {getDealText()}
    </button>
  );
};

export default DealButton;
